/*  MUI  */
import { Skeleton } from '@mui/material';

/*  Reports  */
import ApplicationFunnelReports from 'application/Home/Reports/ApplicationFunnelReports';
import { ApplicationMapReports } from 'application/Home/Reports/ApplicationMapReports';
import { ApplicationOverlapReport } from 'application/Home/Reports/ApplicationOverlap/ApplicationOverlapReport';
import { BrowserReport } from 'application/Home/Reports/Browser/BrowserReport';
import CategoryReports from 'application/Home/Reports/CategoryReports';
import LibraryReports from 'application/Home/Reports/LibraryReports';
import Offboard from 'application/Home/Reports/Offboard/Report';
import PartnerAppUsage from 'application/Home/Reports/PartnerApps/Usage';
import { PartnerClientDeploymentStageReports } from 'application/Home/Reports/PartnerClientDeploymentStageReports';
import { QBRFirstReports } from 'application/Home/Reports/QBR/QBR';
import { StatusReports } from 'application/Home/Reports/StatusReports';
import Usage from 'application/Home/Reports/Usage/Usage';
import UserApps from 'application/Home/Reports/UserApps/UserApps';

/*  Shared  */
import { Helpers } from 'application/Shared/Helpers';
import { Requests } from 'application/Shared/Requests';
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';

/*  NPM  */
import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'router/withRouter';

/*  State  */
const state = () => ({
    configurationError: false,
    loaded: false,
    reportResponse: { reportData: {} }
});

class ReportWrapper extends PureComponent {
    constructor(props) {
        super(props);
        this.state = state();

        /* requests */
        this.requests = new Requests();
    }

    componentDidMount() {
        this.load();
    }

    componentWillUnmount() {
        this.unmounted = true;
        this.unload();
    }

    load = async () => {
        if (this.unmounted) {
            return;
        }

        const config = await this.getConfig();
        if (!config) {
            return;
        }

        if (this.unmounted) {
            return;
        }
        this.setState((_s, props) => {
            this.loadReport({ config, props });
        });
    };

    loadReport = async (p) => {
        const { config, props } = p;
        const {
            applicationOrCategorySelection,
            applicationSelection,
            disableUnclassified,
            endTime,
            period,
            reportCheckbox,
            reportSelection,
            startTime,
            statusSelection,
            tagSelection,
            type,
            useCache
        } = props;

        let reportPayload = {
            applicationOrCategorySelection: 'all',
            applicationSelection: '[0]',
            groupSelection: '[0]',
            period: 'weekly',
            platformSelection: '[0]',
            startTime: new Date().getTime(),
            statusSelection: '[0]',
            tagSelection: '[0]',
            userOrGroupSelection: 'all',
            userSelection: '[0]'
        };
        let configurationError = false;

        if (!type) {
            configurationError = true;
        } else {
            reportPayload = { ...reportPayload, type };
        }

        if (!reportSelection) {
            configurationError = true;
        } else {
            reportPayload = {
                ...reportPayload,
                reportSelections: {
                    [type + reportSelection + reportCheckbox]: true
                }
            };
        }

        if (applicationSelection) {
            reportPayload = {
                ...reportPayload,
                applicationSelection: `[${applicationSelection.join(',')}]`
            };
        }

        if (applicationOrCategorySelection) {
            reportPayload = {
                ...reportPayload,
                applicationOrCategorySelection
            };
        }

        if (period) {
            reportPayload = { ...reportPayload, period };
        }

        if (startTime) {
            reportPayload = { ...reportPayload, startTime };
        }

        if (endTime) {
            reportPayload = { ...reportPayload, endTime };
        }

        if (statusSelection) {
            reportPayload = { ...reportPayload, statusSelection };
        }

        if (tagSelection) {
            reportPayload = { ...reportPayload, tagSelection };
        }

        if (disableUnclassified) {
            reportPayload = { ...reportPayload, disableUnclassified };
        }

        if (useCache) {
            reportPayload.useCache = useCache;
        }

        if (this.unmounted) return;

        let report;
        let subReport;
        config.forEach((item) => {
            if (item.type === reportPayload.type) {
                report = item;
                const { checkboxes } = item;

                Object.values(checkboxes).forEach((checkbox) => {
                    const { subOptions } = checkbox;
                    Object.values(subOptions).forEach((subOption) => {
                        if (
                            checkbox.type + subOption.key ===
                            reportSelection + reportCheckbox
                        ) {
                            subReport = checkbox;
                        }
                    });
                });
            }
        });

        if (report === undefined || subReport === undefined) {
            return;
        }

        const endpoint = `/reports/${subReport.reportEndpoint}`;

        if (this.unmounted) return;
        const [reportRunError, reportResponse] = await this.runReport(
            endpoint,
            reportPayload
        );

        if (this.unmounted) return;
        this.setState({
            configurationError,
            loaded: true,
            reportPayload,
            reportResponse,
            reportRunError
        });
    };

    unload = () => {
        this.requests.cancel();
    };

    getConfig = async () => {
        const { match } = this.props;
        const { clientId } = match.params;

        const params = {};
        if (clientId) {
            params.platformTenantId = clientId;
            params.includeClients = true;
        }

        try {
            const response = await axios.get('/reports/config', {
                cancelToken: this.requests.token(),
                params
            });
            if (!Helpers.isset(response, 'data', 'data')) {
                debug.e('Error. No data in Report Config:', response);
                return false;
            }

            return response.data.data;
        } catch (e) {
            debug.e('Error getting Report Config:', e);
            return false;
        }
    };

    /*  return [err, reportResponse];  */
    runReport = async (endpoint, p) => {
        const { match } = this.props;
        const { clientId } = match.params;

        const params = { ...p };
        if (clientId) {
            params.platformTenantId = clientId;
        }

        try {
            const response = await axios.get(endpoint, {
                cancelToken: this.requests.token(),
                params
            });
            if (Helpers.isset(response, 'data', 'data')) {
                const { data } = response.data;
                if (data !== null) {
                    return [false, data];
                }
                return [
                    `Empty report data for ${endpoint}`,
                    { reportData: {} }
                ];
            }
            return [`No report data for ${endpoint}`, { reportData: {} }];
        } catch (e) {
            return [
                `Error running report for ${endpoint}, ${e}`,
                { reportData: {} }
            ];
        }
    };

    render() {
        const {
            customLoader,
            noLoader,
            reportSelection,
            saasHealthLineGraphOnly = false
        } = this.props;
        const {
            loaded,
            reportPayload,
            reportResponse,
            configurationError,
            reportRunError
        } = this.state;

        let { height } = this.props;
        if (typeof height === 'undefined') {
            height = 150;
        }

        if (!loaded) {
            if (customLoader) {
                return customLoader;
            }

            if (!noLoader) {
                return (
                    <div
                        style={{
                            display: 'block',
                            height,
                            textAlign: 'center'
                        }}
                    >
                        <Skeleton height={height} />
                    </div>
                );
            }
            return null;
        }

        if (configurationError) {
            debug.e('Report Configuration Error', configurationError);
            return null;
        }

        if (reportRunError) {
            debug.e(reportRunError);
            return null;
        }

        const { reportData } = reportResponse;
        const props = {
            height,
            renderingScheduledReport: false,
            reportData,
            reportSetup: reportPayload,
            reportWrapper: true,
            reportWrapperProps: this.props
        };

        switch (reportSelection) {
            case 'Offboard':
                return (
                    <Offboard
                        renderingScheduledReport={false}
                        reportSetup={reportPayload}
                        reportData={reportData}
                        reportWrapper
                        reportWrapperProps={this.props}
                        height={height}
                    />
                );
            case 'Usage':
                return <Usage {...props} />;
            case 'ApplicationOverlap':
                return <ApplicationOverlapReport {...props} />;
            case 'QBRFirst':
                return (
                    <QBRFirstReports
                        saasHealthLineGraphOnly={saasHealthLineGraphOnly}
                        {...props}
                    />
                );
            case 'Library':
                return <LibraryReports {...props} />;
            case 'Category':
                return <CategoryReports {...props} />;
            case 'ApplicationMap':
                return <ApplicationMapReports {...props} />;
            case 'UserApps':
                return <UserApps {...props} />;
            case 'Browser':
                return <BrowserReport {...props} />;
            case 'ApplicationLifecycleStage':
                return <StatusReports {...props} />;
            case 'All':
                return <ApplicationFunnelReports {...props} />;
            case 'TopApplicationsUsed':
                return <PartnerAppUsage {...props} />;
            case 'ClientStages':
                return <PartnerClientDeploymentStageReports {...props} />;
            default:
                return <>Configuration Error: Cannot Find Report Selection</>;
        }
    }
}
export default withRouter(withTranslation()(ReportWrapper));
